/**
 * Thin wrapper around PostHog (already loaded from index.html).
 * Silent no-op if posthog is not available (SSR, ad blockers).
 */
export function track(event, props = {}) {
  try {
    if (typeof window !== "undefined" && window.posthog && typeof window.posthog.capture === "function") {
      window.posthog.capture(event, props);
    }
  } catch { /* noop */ }
}
